<template>
  <div class="create-customer-drawer">
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      direction="rtl"
      @close="colseDrawer"
    >
      <div class="base" ref="baseHeight">
        <div class="add-item-title" style="margin-top: 0">基本信息</div>
        <el-form
          ref="form"
          :inline="true"
          :model="form"
          :rules="rules"
          label-width="80px"
          size="mini"
          v-enterToNext="true"
        >
          <el-form-item label="公司简称" prop="forShort">
            <el-input v-model="form.forShort" maxlength="20"></el-input>
          </el-form-item>

          <el-form-item label="合同开始" prop="startTime">
            <!-- <el-input v-model="form.startTime" maxlength="20"></el-input> -->
            <el-date-picker
              v-model="form.startTime"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="公司全称" prop="companyName">
            <el-input v-model="form.companyName" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="合同结束" prop="endTime">
            <el-date-picker
              v-model="form.endTime"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="form.phone" maxlength="20"></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="isStop">
            <el-radio-group v-model="form.isStop">
              <el-radio :label="false">启用</el-radio>
              <el-radio :label="true">停用</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="公司地址" prop="address">
            <el-input v-model="form.address" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item label="公司首页">
            <el-input v-model="form.homePage" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="linkman">
            <el-input v-model="form.linkman" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item
            label="统一社会信用代码"
            label-width="135px"
            class="code-input"
            prop="creditCode"
          >
            <el-input v-model="form.creditCode" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="form.email" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item label="公司类型">
            <el-input v-model="form.class" maxlength="50"></el-input>
          </el-form-item>
          <el-col :span="24">
            <el-form-item label="排序">
              <el-input-number
                v-model="form.sort"
                :precision="0"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="所在城市" prop="city">
              <el-cascader
                v-model="form.city"
                clearable
                filterable
                :show-all-levels="true"
                :options="cityList"
                :props="{
                  expandTrigger: 'hover',
                  label: 'Name',
                  value: 'Name',
                  checkStrictly: true,
                }"
                style="width: 100%"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-form-item label="封面图" prop="logo" label-width="81px">
            <el-upload
              :class="{ 'factory-hide-upload': isHideLogoUpload }"
              action=""
              accept=".jpg,.png"
              :limit="1"
              :file-list="form.logo"
              list-type="picture-card"
              :on-exceed="onExceed"
              :on-preview="onPreview"
              :before-remove="removeUploadLogo"
              :http-request="uploadComapnayLogo"
            >
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">
                请上传.jpg/.png格式文件，建议尺寸600*500px，文件大小不超过300kb
              </div>
            </el-upload>
          </el-form-item>
          <!-- <el-row>
            <el-col :md="6"
              ><div class="grid-content bg-purple">123</div></el-col
            >
            <el-col :md="6"
              ><div
                class="grid-content bg-purple-light"
                style="border: 1px solid black"
              >
                33666
              </div></el-col
            >
          </el-row> -->
          <el-col :span="24">
            <el-form-item label="公司简介" class="form-item-block">
              <vue-ueditor-wrap
                v-model="form.desc"
                :config="myConfig"
              ></vue-ueditor-wrap>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div class="rightPadding"></div>
      <div class="submit-bar">
        <el-button @click="colseDrawer()">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="onSubmit"
          >确定</el-button
        >
      </div>
    </el-drawer>
    <el-dialog :visible.sync="imgDialog.show">
      <img width="100%" :src="imgDialog.url" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: {
    VueUeditorWrap,
  },
  props: {
    users: Array,
    title: String,
    drawerShow: Boolean,
    operation: String,
    customerInfo: Object,
    cityList: Array,
  },
  data() {
    return {
      baseHeight: "",
      myConfig: {
        // 设置编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 320,
        // 初始容器宽度
        initialFrameWidth: "100%",

        // UEditor 是文件的存放路径，
        UEDITOR_HOME_URL: "/Ueditor/",
      },
      submitLoading: false,
      drawer: false,
      companyScale: [],
      form: {
        logo: [],
      },
      imgDialog: {
        show: false,
        imgUrl: "",
      },
      currentUserInfo: null,
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
        ],
        forShort: [
          { required: true, message: "请输入公司简称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
        ],
        isStop: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["blur", "change"],
          },
        ],
      },
      personForm: {},
      companyId: "",
      receiver: {
        principal: [],
        own: [],
        other: [],
      },
      customenContacts: [],
    };
  },
  computed: {
    isHideLogoUpload: function () {
      return this.form.logo.length == 1;
    },
    isHideLicenseUpload: function () {
      return this.form.license.length == 1;
    },
  },
  mounted() {},
  methods: {
    validateForm(formName) {
      let isValidate = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          isValidate = true;
        } else {
          isValidate = false;
        }
      });
      return isValidate;
    },
    onSubmit() {
      if (!this.validateForm("form")) return;
      this.submitLoading = true;
      var city = "";
      if (this.form.city) {
        this.form.city.forEach((item, i) => {
          city = city + item;
          if (i < this.form.city.length - 1) {
            city = city + ",";
          }
        });
      }
      let sendData = {
        customerName: this.form.companyName,
        forShort: this.form.forShort,
        customerAddress: this.form.address,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        contactNumber: this.form.phone,
        customerHomepage: this.form.homePage,
        creditCode: this.form.creditCode,
        email: this.form.email,
        theContact: this.form.linkman,
        customerType: this.form.class,
        customerDescribe: this.form.desc,
        customerLogo: this.form.logo[0]?.url || "",
        businessLicense: this.form.license[0]?.url || "",
        isStop: this.form.isStop,
        city: city,
        sort: this.form.sort ? this.form.sort : "",
      };
      if (this.operation == "edit") {
        sendData.id = this.companyId;
      }

      this.$api.customer.addFactory(sendData).then((res) => {
        this.submitLoading = false;

        if (res.error === false) {
          this.$message.success("保存成功");
          this.$emit("refreshData");
        } else {
          this.$message.error(res.msg);
        }
        this.colseDrawer();
        console.log("error=false");
      });
    },

    uploadComapnayLogo(fileObj) {
      this.uploadSingleImage(fileObj, "logo");
    },

    uploadSingleImage(fileObj, imgType) {
      this.uploadImage(fileObj, imgType, this.form);
    },
    onExceed(files, fileList) {
      this.$message.warning("只允许上传一张图片，请移除已上传图片后再进行操作");
    },
    //图片预览
    onPreview(file) {
      this.imgDialog.show = true;
      this.imgDialog.url = file.url;
    },
    removeUploadLogo() {
      this.form.logo = [];
    },
    colseDrawer() {
      this.$emit("colseDrawer");
    },
    //编辑赋值
    fillFormData(customerInfo) {
      console.log(customerInfo);
      this.companyId = customerInfo.id;
      // 基本信息
      this.$set(this.form, "companyName", customerInfo.customerName);
      this.$set(this.form, "forShort", customerInfo.forShort);
      this.$set(this.form, "creditCode", customerInfo.creditCode);
      this.$set(this.form, "address", customerInfo.customerAddress);
      this.$set(
        this.form,
        "city",
        customerInfo.city && customerInfo.city.split(",")
      );
      this.$set(this.form, "industry", customerInfo.industry);
      this.$set(this.form, "companyLevel", customerInfo.customerLevel);
      this.$set(this.form, "startTime", customerInfo.startTime);
      this.$set(this.form, "endTime", customerInfo.endTime);
      this.$set(this.form, "homePage", customerInfo.customerHomepage);
      this.$set(this.form, "linkman", customerInfo.theContact);
      this.$set(this.form, "phone", customerInfo.contactNumber);
      this.$set(this.form, "weChat", customerInfo.weChatNumber);
      this.$set(this.form, "email", customerInfo.email);
      this.$set(this.form, "class", customerInfo.customerType);
      this.$set(this.form, "desc", customerInfo.customerDescribe);
      this.$set(this.form, "isStop", customerInfo.isStop);
      this.$set(
        this.form,
        "sort",
        customerInfo.sort == null ? undefined : customerInfo.sort
      );

      customerInfo.customerLogo &&
        this.form.logo.push({
          name: "企业LOGO",
          url: customerInfo.customerLogo,
        });
    },

    getUserInfo() {
      const memberId = JSON.parse(localStorage.getItem("Authorization"))
        ? JSON.parse(localStorage.getItem("Authorization")).memberId
        : "";
      if (!memberId) return;
      this.$api.user.getUserInfo(memberId).then((res) => {
        if (res.code === 0) {
          this.currentUserInfo = res.data;
        }
      });
    },
  },
  watch: {
    drawerShow(val) {
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
      this.drawer = val;
      if (this.drawer == false) {
        this.companyId = "";
        this.form = {
          logo: [],
        };
        return;
      }
      if (this.operation == "edit") {
        this.fillFormData(this.customerInfo);
      }
    },
  },
};
</script>

<style lang="less">
.factory-hide-upload {
  .el-upload--picture-card {
    display: none;
  }
  .el-upload__tip {
    margin-top: 0;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 170px !important;
    height: 146px !important;
  }
}
.add-item-title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0;
}
#el-drawer__title span {
  color: black;
  font-weight: 700 !important;
  font-size: 16px;
}
.create-customer-drawer {
  .el-drawer {
    width: 78% !important;
    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      // display: flex;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .base {
    width: 80%;
    float: left;
    padding: 17px 20px 60px 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;
    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 85%;
      }
      .el-select {
        width: 100%;
      }
    }
    .code-input {
      .el-form-item__content {
        width: calc(85% - 55px);
      }
    }
    .form-item-block {
      width: 100%;
      .el-form-item__content {
        width: 90%;
      }
    }
  }
  .rightPadding {
    width: 20%;
    height: 100%;
    float: right;
    // background-color: rgba(0, 0, 0, 0.03);
  }
}
.submit-bar {
  position: absolute;
  z-index: 99;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
  .el-button {
    padding: 8px 20px;
  }
}
</style>
